import { VOICE_RECORDING_ERROR } from "@arbolus-technologies/models/common";

export const PREFERRED_AUDIO_TYPES = [
  "audio/webm;codecs=opus",
  "audio/webm",
  "audio/ogg;codecs=opus",
  "audio/mp4"
];

export const RECORDING_TICK_INTERVAL_MS = 1000;

// Maps the DOMException.name thrown by getUserMedia to a specific cause so the
// user gets an actionable message instead of a generic failure.
export const GET_USER_MEDIA_ERROR_MAP: Record<string, VOICE_RECORDING_ERROR> = {
  NotAllowedError: VOICE_RECORDING_ERROR.PERMISSION_DENIED,
  SecurityError: VOICE_RECORDING_ERROR.PERMISSION_DENIED,
  NotFoundError: VOICE_RECORDING_ERROR.NO_MICROPHONE,
  DevicesNotFoundError: VOICE_RECORDING_ERROR.NO_MICROPHONE,
  OverconstrainedError: VOICE_RECORDING_ERROR.NO_MICROPHONE,
  NotReadableError: VOICE_RECORDING_ERROR.MICROPHONE_IN_USE,
  TrackStartError: VOICE_RECORDING_ERROR.MICROPHONE_IN_USE,
  AbortError: VOICE_RECORDING_ERROR.MICROPHONE_IN_USE
};

export const getSupportedAudioType = (): string | null => {
  for (const mimeType of PREFERRED_AUDIO_TYPES) {
    if (MediaRecorder.isTypeSupported(mimeType)) {
      return mimeType;
    }
  }
  return null;
};
